import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";
import InputFormExtension from "@/Layouts/components/InputComponents/InputFormExtension";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";
import TierRowsItem from "@/Layouts/components/Tiers/TierRowsItem";
import { TInputData } from "@/Layouts/types/InputComponents/InputFormExtension";
import { Stack } from "@mui/material";
import { CSSProperties } from "react";
import { ITiers, TTierCommission } from "../../../../types/spiffSetup";

type MatrixRowProps = {
	readOnly?: boolean;
	index?: number;
	item?: ITiers;
	spaces?: object;
	spacing?: string;
	fromDisabled?: boolean;
	toDisabled?: boolean;
	mainContentProps?: object;
	sxMainContent?: object;
	sxCells?: object;
	cellsProps?: object;
	commissionsErrors?: { commission: boolean }[][];
	unitsErrors?: { from: boolean; to: boolean }[];
	isLastCommissionValid: boolean;
	rowsLength: number;
	bonusInputDefinitions?: TInputData[];
	inputSx?: CSSProperties;
	onActionUpdate?: (a: number, b: number, c: string, d: string, e: NumberOrString) => void;
	onChangeType?: (a: number, b: number, c: string, d: string, e: string) => void;
};

const MatrixRow = (props: MatrixRowProps) => {
	const {
		readOnly,
		item = null,
		index = 0,
		spaces = {},
		spacing = 0,
		mainContentProps = {},
		sxCells = {},
		cellsProps = {},
		sxMainContent,
		fromDisabled = false,
		toDisabled = false,
		isLastCommissionValid = false,
		rowsLength = 0,
		commissionsErrors = [],
		unitsErrors = [],
		bonusInputDefinitions = [],
		inputSx = {},
		onActionUpdate = () => {},
		onChangeType = () => {},
	} = props;

	const doubleInputDefinition = {
		type: "Unit",
		min: 0,
		max: 100000,
		delta: 0.5,
		decimals: 1,
		decimalsEditable: true,
	};

	return (
		<TierRowsItem hasShadow={!(index % 2)} spaces={spaces}>
			<Stack direction={"row"} spacing={spacing}>
				<Stack {...mainContentProps} sx={sxMainContent}>
					<DoubleInput
						firstInput={{
							data: [{ ...doubleInputDefinition, dashed: fromDisabled }],
							sx: { width: "70px" },
							defaultType: item?.from?.input ?? "Dollar",
							value: item?.from?.value ?? 0,
							error: Boolean(unitsErrors?.[index]?.from),
							disabled: fromDisabled,
							readOnly: true,
						}}
						secondInput={{
							readOnly,
							data: [{ ...doubleInputDefinition, dashed: toDisabled }],
							sx: { width: "70px" },
							defaultType: item?.to?.input ?? "Dollar",
							value: item?.to?.value ?? 0,
							error: Boolean(unitsErrors?.[index]?.to),
							disabled: toDisabled,
							onActionUpdate: (value) => {
								onActionUpdate?.(index, 0, "row", "to", value);
							},
						}}
					/>
				</Stack>
				<Stack direction={"row"} spacing={spacing}>
					{item?.commissions?.map((element: TTierCommission, key: number) => {
						const lastCellError = !isLastCommissionValid && key === item?.commissions?.length - 1 && index === rowsLength - 1;
						const rowIndexKey = `${index}_${key}`;
						return (
							<Stack key={rowIndexKey} {...cellsProps} sx={sxCells}>
								<InputFormExtension
									data={bonusInputDefinitions}
									value={element?.commission?.value || 0}
									defaultType={element?.commission?.input || "Dollar"}
									error={Boolean(commissionsErrors?.[index]?.[key]?.["commission"]) || lastCellError}
									disabled={readOnly}
									readOnly={readOnly}
									onChangeType={(_, input) => {
										onChangeType?.(index, key, "row", "commission", input);
									}}
									onActionUpdate={(value) => {
										onActionUpdate?.(index, key, "row", "commission", value);
									}}
									sx={inputSx}
								/>
							</Stack>
						);
					})}
				</Stack>
			</Stack>
		</TierRowsItem>
	);
};

export default MatrixRow;
